import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Close from '@material-ui/icons/Close';
import TextField from '../../../../../../../app/components/textField';
import MuiTextField from '@material-ui/core/TextField';
import { FlatButton } from '../../../../../../../app/components/buttons';
import CircularValidation from '../../../../../../../app/components/circularValidation';
import { CircularProgress } from '../../../../../../../app/components/progress';
import './styles.css';
import { Link } from 'react-router-dom';
import { whitelabeledHost } from '../../../../../../../utils/whitelabeledHost';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@material-ui/core';

const isWhiteLabelledHost = whitelabeledHost();

const NewAdmin = props => {
  const {
    open,
    pending,
    error,
    onSubmit,
    onRequestClose,
    firstName,
    lastName,
    email,
    password,
    onFieldChange,
    adminAppname,
    match,
    apps,
    smsCredits,
    whatsappSMSCredits,
    adminSMSCredits,
    adminWhatsappSMSCredits,
    hasCustomDomain,
    checkAppDetails,
  } = props;
  const handleAppChange = e => {
    onFieldChange('adminAppname', e.target.value);
    checkAppDetails(e.target.value);
  };
  const superAdminApps = Object.keys(apps);

  const displayError = error ? (
    <div>
      <strong>{error}</strong>
    </div>
  ) : null;

  const form = (
    <div>
      <h5>Create an Admin</h5>
      <TextField
        id="firstName"
        placeholder="First Name"
        {...firstName}
        onChange={value => onFieldChange('firstName', value)}
        rightInputAction={
          <CircularValidation
            isValid={firstName.isValid}
            defaultMsg="Admin's first name required"
            errorMsg="First name must be at least 2 characters long"
            showDefault={!firstName.value}
          />
        }
      />
      <TextField
        id="lastName"
        placeholder="Last Name"
        {...lastName}
        onChange={value => onFieldChange('lastName', value)}
        rightInputAction={
          <CircularValidation
            isValid={lastName.isValid}
            defaultMsg="Admin's last name required"
            errorMsg="Last name must be at least 2 characters long"
            showDefault={!lastName.value}
          />
        }
      />
      <TextField
        id="email"
        placeholder="Email"
        {...email}
        onChange={value => onFieldChange('email', value)}
        rightInputAction={
          <CircularValidation
            isValid={email.isValid}
            defaultMsg="Email address required"
            errorMsg="Please use a valid email address"
            showDefault={!email.value}
          />
        }
      />
      <TextField
        id="password"
        placeholder="Password"
        type="password"
        {...password}
        onChange={value => onFieldChange('password', value)}
        rightInputAction={
          <CircularValidation
            isValid={password.isValid}
            defaultMsg="Password required"
            errorMsg="Password must be at least 6 characters long"
            showDefault={!password.value}
          />
        }
      />

      <div className="text-field-wrapper">
        <FormControl fullWidth>
          <InputLabel id="app-select-label" style={{ left: '-15px' }}>
            Select app
          </InputLabel>
          <Select
            labelId="app-select-label"
            id="app-select"
            multiple
            value={adminAppname.value}
            onChange={e => handleAppChange(e)}
            variant="standard"
          >
            {Object.keys(apps).map(appId => (
              <MenuItem value={appId}>{apps[appId].title}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="text-field-wrapper" style={{ marginTop: '14px' }}>
        <MuiTextField
          variant="standard"
          type="number"
          fullWidth
          label="SMS Credits"
          value={adminSMSCredits.value}
          onChange={e =>
            e.target.value >= 0 &&
            e.target.value <= smsCredits &&
            onFieldChange('adminSMSCredits', e.target.value)
          }
          inputProps={{ min: 0, max: smsCredits }}
          InputProps={{ endAdornment: `/${smsCredits}` }}
          helperText="These credits will be deducted from your account."
        />
      </div>

      <div className="text-field-wrapper" style={{ marginTop: '14px' }}>
        <MuiTextField
          variant="standard"
          type="number"
          fullWidth
          label="Whatsapp Credits"
          value={adminWhatsappSMSCredits.value}
          onChange={e =>
            e.target.value >= 0 &&
            e.target.value <= whatsappSMSCredits &&
            onFieldChange('adminWhatsappSMSCredits', e.target.value)
          }
          inputProps={{ min: 0, max: whatsappSMSCredits }}
          InputProps={{ endAdornment: `/${whatsappSMSCredits}` }}
          helperText="These credits will be deducted from your account."
        />
      </div>
    </div>
  );

  const buttonSubmit = !pending ? (
    <FlatButton
      label={'Create'}
      onClick={onSubmit}
      disabled={
        !firstName.isValid ||
        !lastName.isValid ||
        !email.isValid ||
        !password.isValid ||
        !adminAppname.isValid ||
        !superAdminApps.some(v => adminAppname.value.includes(v))
      }
      primary
    />
  ) : (
    <CircularProgress size={18} />
  );

  return (
    <Dialog open={open} onClose={onRequestClose} autoScrollBodyContent>
      <DialogTitle>
        <div className="modal-controls-container">
          <IconButton onClick={onRequestClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="scroll-container">
        <div className="add-admin-form">
          <div className="list-fieldset">{displayError}</div>
          {form}
          {!hasCustomDomain && (
            <section className="info-box">
              <div className="instruction-box">
                <p className="info">
                  We recommend adding a custom domain to your{' '}
                  <a
                    href="https://beezer.zendesk.com/hc/en-us/articles/360048189151-Custom-Domain"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontWeight: 700 }}
                  >
                    appshell
                  </a>{' '}
                  and to your{' '}
                  <a
                    href="https://beezer.zendesk.com/hc/en-us/articles/360048189151-Custom-Domain"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontWeight: 700 }}
                  >
                    admin dashboard
                  </a>{' '}
                  before creating an app admin. By setting up a custom domain
                  you will hide the “.beezer.com” URL in the admin dashboard and
                  the appshell.
                </p>

                <p className="info">
                  Set up{' '}
                  <Link
                    to={`/${match.params.appname}/editor/build/custom_domain`}
                  >
                    custom domain
                  </Link>{' '}
                  for appshell.
                </p>
                <p>
                  Set up{' '}
                  <Link
                    to={`/${match.params.appname}/editor/build/custom_domain`}
                  >
                    custom domain
                  </Link>{' '}
                  for admin dashboard.
                </p>
              </div>
            </section>
          )}
          {buttonSubmit}
        </div>
      </DialogContent>
    </Dialog>
  );
};

NewAdmin.propTypes = {
  open: PropTypes.bool.isRequired,
  error: PropTypes.string,
  pending: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  firstName: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.bool,
  }).isRequired,
  adminAppname: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.bool,
  }).isRequired,
  lastName: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.bool,
  }).isRequired,
  email: PropTypes.shape({ value: PropTypes.string, isValid: PropTypes.bool })
    .isRequired,
  password: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.bool,
  }).isRequired,
  onFieldChange: PropTypes.func.isRequired,
  apps: PropTypes.object.isRequired,
};

NewAdmin.defaultProps = {
  error: null,
};

export default NewAdmin;
